export const FLAGS = {
  SPLIT_PAYMENT: 'checkout_customization_enable_split_payment',
  INSTANT_REFUND: 'checkout_customization_enable_instant_refunds',
};